import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import Container from "@components/Atomic/Container/Container";
import { Link } from "@components/Link/Link";
import { PageTitle } from "@components/PageTitle/PageTitle";
import { StyledButton } from "@components/Styled/Button";
import { StyledContainer } from "@components/Styled/Container";
import React from "react";
import tw, { styled } from "twin.macro";
import { withTitle } from "./withTitle";

const Button = tw(StyledButton)`
  max-w-[330px] w-full my-mini
`;

const UnderlinedButton = withFocusRing(tw.button`
  text-body leading-caption border-b mb-mini hover:text-warning hover:border-warning
`);

const Richtext = styled.div`
  .rte {
    ${tw`mt-mini`}
    p {
      ${({ textCenter }) => (textCenter ? tw`text-center` : tw`text-left`)}
    }
  }
`;

export const Title = withTitle(
  ({
    styles,
    title,
    paths,
    buttonTitle,
    buttonLink,
    buttonStyle,
    content,
    width,
    textCenter,
    titleWidth,
    titleBackground,
  }) => (
    <PageTitle
      styles={styles}
      title={title}
      paths={paths}
      width={titleWidth}
      background={titleBackground}
      data-component-type="section-title"
    >
      <>
        {buttonLink && buttonStyle === "button" ? (
          <Button
            colour="secondary"
            height="56"
            textSize="16"
            as={buttonLink ? Link : null}
            to={buttonLink}
          >
            {buttonTitle}
          </Button>
        ) : null}
        {buttonLink && buttonStyle === "underlined" ? (
          <UnderlinedButton as={buttonLink ? Link : null} to={buttonLink}>
            {buttonTitle}
          </UnderlinedButton>
        ) : null}
        {content && (
          <StyledContainer width={width}>
            <Richtext textCenter={textCenter}>
              <div className={"rte"}>{content}</div>
            </Richtext>
          </StyledContainer>
        )}
      </>
    </PageTitle>
  ),
);

export default Title;
